<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 150px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/inventory')") Inventory
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Services
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/packages')") Packages
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/stocktakes')") Stock take
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="company.is_hq || company.branch_of" @click="$router.push('/admin/clinic/branches-warehouses')") Branches & Warehouses
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/locations')") Locations
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="Auth('root', 'subscribe_purchase_hub')" @click="$router.push('/admin/clinic/inventory-list')") List

    v-col.grow
      v-container.py-8(fluid)
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="neutral700" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Services

        v-row.pb-2.pb-md-0(no-gutters)
          v-col(cols="12" md="7")
            v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold" @change="tabChanged(tabs)")
              v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
              v-tab.text-sm.font-medium.text-none.px-4 Service
              v-tab.text-sm.font-medium.text-none.px-4 Procedure
              v-tab.text-sm.font-medium.text-none.px-4 Investigation
              v-tab.text-sm.font-medium.text-none.px-4 Consultation
              v-tab.text-sm.font-medium.text-none.px-4 Archived

          v-col(cols="12" md="5" align="end")
            .d-flex.align-center
              v-spacer
              v-btn(@click="clickSearch" icon color="neutral500")
                v-icon(size="20") $yzi-search-sm
              v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
              div
                customize-column-menu(type="service" :showTooltip="false" iconSize="21")
              v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addNewService") {{ $t('create_service') }}
        v-divider

        filter-services-row.my-2(ref="filter" :filters.sync="filters" :prop-filters="saveFilters")
        v-skeleton-loader.mt-sm-4.pb-6(v-if="isFetching" type="table-tbody")
        .data-table(v-else)
          v-data-table.mt-sm-4.pb-6(:headers="headers" :items="services" item-key="id" :items-per-page="pageSize" hide-default-footer :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" :server-items-length="totalCount" @update:sort-by="sortBy = $event" @update:sort-desc="sortIsDesc = $event" @click:row="editService")
            //- name
            template(v-slot:item.name="{ item }")
              .d-flex.align-center.justify-space-between
                .yz-medium-body-sm.neutral700--text {{ item.product.name }}
                yz-badge(v-if="item.product.branch_for" x-small color="blue-100" text-color="blue-500" border) HQ
            //- type
            template(v-slot:item.type="{ item }")
              .text-sm.neutral700--text.capitalize {{ item.type }}
            //- description
            template(v-slot:item.description="{ item }")
              v-tooltip(top color="neutral700")
                template(#activator="{ on, attrs }")
                  div(v-bind="attrs" v-on="on" style="max-width: 175px;")
                    .text-sm.neutral700--text.cursor-help.ellipsis-text {{ item.product.description }}
                div.text-xs(style="max-width: 500px;") {{ item.product.description }}
            //- cost
            template(v-slot:item.cost="{ item }")
              .text-sm.success500--text {{ item.cost | displayPrice($currency) }}
            //- price range
            template(v-slot:item.price="{ item }")
              .text-sm.success500--text {{ item.price_range[0] | displayPrice($currency) }}
                span.text-sm.success500--text(v-if="item.price_range.length > 1") &nbsp; - {{ item.price_range[1] | displayPrice($currency) }}
            //- //- status
            template(v-slot:item.status="{ item }")
              y-chip(v-if="item.status === 'published'" label="Active" color="green")
                template(#prepend)
                  v-icon.mr-1(size="12" color="success600") mdi-record
              y-chip(v-else label="Archived" color="red")
                template(#prepend)
                  v-icon.mr-1(size="12" color="danger600") mdi-record
            //- actions
            template(v-slot:item.actions="{ item, index }")
              div.d-flex(@click.stop)
                v-spacer
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="editService(item)")
                      v-list-item-title.text-sm.basic800--text Edit service
                    v-divider
                    v-list-item(@click="goToServiceHistory(item)")
                      v-list-item-title.text-sm.basic800--text Service history
                    v-divider(v-if="!item.product.branch_for")
                    v-list-item(v-if="!item.product.branch_for" @click="changeStatus(item)")
                      v-list-item-title.text-sm.basic800--text {{ item.status === 'published' ? 'Archive' : 'Activate' }}
                    v-divider(v-if="!item.product.branch_for")
                    v-list-item(v-if="!item.product.branch_for" @click="deleteService(item)")
                      v-list-item-title.text-sm.danger500--text Delete service

        div.fill-width
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show item" attach menu-top @input="pageChanged" @pageSizeChanged="fetchFirstPage")

  y-sorter(v-model="ordering" :headers="headers" :sort-by="sortBy" :is-desc="sortIsDesc")
  .dialogs
    delete-service-dialog(v-if="showDeleteServiceDialog" :open.sync="showDeleteServiceDialog" :service="selectedService" @closed="closed" @deleted="reset")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import FilterServicesRow from '@/components/clinic/inventory/FilterServicesRow.vue'
import DeleteServiceDialog from '@/components/clinic/dialogs/DeleteServiceDialog.vue'
import YSorter from "@/components/YSorter.vue";

export default {
  name: 'Services',
  components: {YSorter, CustomizeColumnMenu, FilterServicesRow, DeleteServiceDialog },
  props: ['savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  data: () => ({
    isFetching: false,
    isChecking: false,
    searchText: '',
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    services: [],
    tabs: 0,
    selectedService: null,
    showSearchField: false,
    showDeleteServiceDialog: false,
    filters: [],
    sortBy: null,
    sortIsDesc: false,
    ordering: null,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      serviceFields: 'clinic/getServiceFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Name', value: 'name', enable: true, sort_query_param: 'product__name' }
      const fields = this.serviceFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false
      }
      return [name, ...fields, actions]
    },
  },
  watch: {
    filters () {
      if (this.isChecking) {
        this.fetchServices()
      } else {
        this.fetchFirstPage()
      }
    },
    ordering (val) {
      this.currentPage = 1
      if (val === null || val === undefined) {
        localStorage.removeItem('yz_services_ordering')
      } else {
        localStorage.setItem('yz_services_ordering', val)
      }
      if (!this.isChecking) {
        this.fetchServices()
      }
    }
  },
  mounted () {
    this.checkProps()
    this.checkOrdering()
    this.headers.map(item => item['class'] = 'text-table-header')
    if (this.saveFilters) {
      this.$refs.filter.setFilters()
    } else {
      this.fetchServices()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    checkOrdering () {
      const savedOrdering = localStorage.getItem('yz_services_ordering')
      if (savedOrdering) {
        this.ordering = savedOrdering
      }
    },
    fetchServices () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage,
        ordering: this.ordering
      }
      if (this.tabs === 1) { params.type = 'service' }
      if (this.tabs === 2) { params.type = 'procedure' }
      if (this.tabs === 3) { params.type = 'investigation' }
      if (this.tabs === 4) { params.type = 'consultation' }
      if (this.tabs === 5) { params.status = 'draft' }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/clinics/${this.company.slug}/services`, { params })
        .then(resp => {
          this.services = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchServices()
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    pageChanged () {
      this.fetchServices()
    },
    tabChanged () {
      this.searchText = null
      this.fetchFirstPage()
    },
    checkProps () {
      this.isChecking = true
      if (this.saveSearch) {
        this.searchText = this.saveSearch
        this.clickSearch()
      }
      if (this.savePage) {
        this.currentPage = this.savePage
      }
      if (this.saveTab) {
        this.tabs = this.saveTab
      }
      setTimeout(() => {
        this.isChecking = false
      }, 2000)
    },
    addNewService () {
      this.$router.push('/admin/clinic/service')
    },
    editService (item) {
      let params = {
        id: item.id,
        savePage: this.currentPage,
        saveTab: this.tabs,
        saveSearch: this.searchText,
        saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
      }
      this.$router.push({ name: 'ClinicEditService', params })
    },
    goToServiceHistory (item) {
      this.$router.push({ name: 'ServiceHistory', params: { id: item.id, origin: 'ClinicServices' } })
    },
    deleteService (item) {
      this.selectedService = item
      this.showDeleteServiceDialog = true
    },
    changeStatus (item) {
      this.isFetching = true
      let newStatus = 'published'
      if (item.status === 'published') {
        newStatus = 'draft'
      }
      this.$axios.patch(`/clinics/${this.company.slug}/services/${item.id}`, { product: { status: newStatus } })
        .then(() => {
          this.fetchServices()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.services.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
    reset () {
      this.fetchFirstPage()
      this.closed()
    },
    closed () {
      this.selectedService = null
      this.showDeleteServiceDialog = false
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
::v-deep .v-slide-group__prev, .v-slide-group__next {
  flex: 0 1 16px !important;
  min-width: 16px !important;
}
::v-deep .v-tab {
  min-width: 24px !important;
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>